import { ButtonProps, Select, SelectProps } from 'antd';
import { useMemo } from 'react';

import { SelectWithButton } from '../select-with-button';
import { OptionTypeModel } from './select-with-complementary-label.model';
import * as Styled from './select-with-complementary-label.style';

export interface SelectWithComplementaryLabelProps extends SelectProps {
  options?: OptionTypeModel[];
  buttonProps?: ButtonProps;
}

const renderOptionLabel = (option: OptionTypeModel) =>
  option.complementaryLabel && option.label ? (
    <>
      {option.label}
      <Styled.SpanComplementaryLabel>{`(${option.complementaryLabel})`}</Styled.SpanComplementaryLabel>
    </>
  ) : (
    option.label
  );

export const SelectWithComplementaryLabel = ({
  options,
  buttonProps,
  ...props
}: SelectWithComplementaryLabelProps) => {
  const renderOptions = useMemo(
    () =>
      options?.map((option) =>
        option.options
          ? {
              ...option,
              options: option.options.map((child: OptionTypeModel) => ({
                ...child,
                label: renderOptionLabel(child),
              })),
            }
          : { ...option, label: renderOptionLabel(option) },
      ),
    [options],
  );

  if (buttonProps) {
    return (
      <SelectWithButton
        {...props}
        options={renderOptions}
        buttonProps={buttonProps}
      />
    );
  }

  return <Select {...props} options={renderOptions} />;
};
